export const DataCorrelationMapper = {
  toGraphData: classificationMetricsReportData => ({
    metricCalculationName: classificationMetricsReportData?.MeasurementCalculationName,
    quarterlyAverages:
      classificationMetricsReportData?.QuarterlyReportData.map(item => ({
        quarter: {
          displayName: item.Quarter.DisplayName,
          year: item.Quarter.Year,
          quarterNum: item.Quarter.QuarterNum
        },
        average: item.Average
      })) || []
  }),

  toPracticeAreaReportData: practiceAreaReportData => {
    return practiceAreaReportData.map(report => ({
      practiceGroupLevel: report.Practice.PracticeGroup.Level,
      numberWithinLevel: report.Practice.NumberWithinLevel,
      description: report.Practice.Name,
      quarterlyData: report.QuarterlyData.map(item => ({
        quarter: {
          displayName: item.Quarter.DisplayName,
          year: item.Quarter.Year,
          quarterNum: item.Quarter.QuarterNum
        },
        average: item.Average
      }))
    }));
  }
};
